import React, { useEffect, useState } from 'react';
import Config from '../../../helpers/Config';
import { translateText } from '../../../helpers/LanguageHelper';

const api = path => new URL('api/customer-push/' + path, Config.ADMIN_BASE_URL).href;
const supported = () => window.isSecureContext && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
async function send(path, subscription) {
    const response = await fetch(api(path), {method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify(subscription.toJSON())});
    if(!response.ok) throw new Error('Subscription could not be saved');
}
function applicationKey(value) {
    const raw=atob(value.replace(/-/g,'+').replace(/_/g,'/') + '='.repeat((4-value.length%4)%4));
    return Uint8Array.from(raw,c=>c.charCodeAt(0));
}
export default function CustomerPushOptIn() {
    const [subscribed,setSubscribed]=useState(false);
    const [busy,setBusy]=useState(true);
    const [message,setMessage]=useState('Get offers and updates from UKL Butter.');
    useEffect(()=>{
        if(!supported()) return;
        let cancelled=false;
        navigator.serviceWorker.register('/ukl-push-sw.js').then(reg=>reg.pushManager.getSubscription()).then(async subscription=>{
            if(subscription && !cancelled) {
                setSubscribed(true);
                window.dispatchEvent(new Event('ukl-notifications-enabled'));
                setMessage('You are subscribed to UKL Butter offers and updates.');
                await send('subscribe',subscription);
            }
        }).catch(()=>{
            if(!cancelled) setMessage('We could not check notifications. Please try again.');
        }).finally(()=>{ if(!cancelled) setBusy(false); });
        return ()=>{cancelled=true;};
    },[]);
    if(!supported() || subscribed) return null;
    const toggle=async()=>{
        if(busy) return;
        setBusy(true);
        try {
            if(!subscribed && Notification.permission!=='granted') {
                const permission=await Notification.requestPermission();
                if(permission!=='granted') { setMessage('To receive updates, allow notifications in your browser site settings.'); return; }
            }
            const registration=await navigator.serviceWorker.register('/ukl-push-sw.js');
            let subscription=await registration.pushManager.getSubscription();
            if(subscribed) {
                if(subscription) {
                    await send('unsubscribe',subscription);
                    if(!await subscription.unsubscribe()) throw new Error('Browser unsubscribe failed');
                }
                setSubscribed(false);setMessage('Notifications are turned off for this browser.');
            } else {
                const response=await fetch(api('public-key'),{credentials:'omit',cache:'no-store'});
                if(!response.ok) throw new Error('Unavailable');
                const data=await response.json();
                // Wait for this registration to activate before subscribing.
                await navigator.serviceWorker.ready;
                if(!subscription) subscription=await registration.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:applicationKey(data.publicKey)});
                await send('subscribe',subscription);
                setSubscribed(true);setMessage('You are subscribed to UKL Butter offers and updates.');
                window.dispatchEvent(new Event('ukl-notifications-enabled'));
            }
        } catch { setMessage('We could not update notifications. Please try again.'); }
        finally { setBusy(false); }
    };
    return <aside aria-label="UKL Butter notifications" style={{background:'#fff9ec',borderBottom:'1px solid #eadbb8',padding:'10px 20px',display:'flex',gap:12,alignItems:'center',justifyContent:'center',flexWrap:'wrap'}}>
        <span role="status" style={{fontSize:13,color:'#4b432e'}}>{translateText(message)} {translateText('Applies to this browser only. Email subscriptions are separate.')}</span>
        <button type="button" onClick={toggle} disabled={busy} style={{background:'#39552b',color:'#fff',border:0,borderRadius:20,padding:'8px 16px',fontSize:13,cursor:'pointer'}}>{translateText(busy?'Please wait...':subscribed?'Turn off notifications':'Enable notifications')}</button>
    </aside>;
}
